import dedent from 'ts-dedent';
import { WorkflowCodeType, WorkflowComponentOutputType, WorkflowComponentParamType } from '../types';
import { WorkflowComponent } from './common/workflowcomponent';
class ReadQuery extends WorkflowComponent {
    constructor() {
        super({
            name: ReadQuery.NAME,
            group: '__internal',
            title: 'Read Query',
            description: ''
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.String,
                title: 'Source query'
            },
            {
                name: 'tags',
                type: WorkflowComponentParamType.String,
                title: 'Tags',
                default: '',
                optional: true
            }
        ], [
            {
                name: 'out',
                title: 'View',
                description: 'The output view',
                type: WorkflowComponentOutputType.View
            }
        ]);
        this.hidden = true;
    }
    async getCode({ workflow, params, connection, codeType }) {
        let viewname;
        let query;
        if (codeType === WorkflowCodeType.DryRun) {
            const viewnameDryRun = connection.getOutputViewName(workflow.id, this.metadata.name, params, 'out', WorkflowCodeType.DryRun);
            const queryDryRun = this.getInnerSql({
                params,
                connection,
                viewname: viewnameDryRun
            });
            const viewnameFull = connection.getOutputViewName(workflow.id, this.metadata.name, params, 'out', WorkflowCodeType.Full);
            const queryFull = this.getInnerSql({
                params,
                connection,
                viewname: viewnameFull
            });
            viewname = viewnameDryRun;
            query = dedent `${queryDryRun}\n${queryFull}`;
        }
        else {
            viewname = connection.getOutputViewName(workflow.id, this.metadata.name, params, 'out', codeType);
            query = this.getInnerSql({
                params,
                connection,
                viewname
            });
        }
        return {
            query,
            outputs: { out: viewname }
        };
    }
    getInnerSql({ params, connection, viewname }) {
        viewname || (viewname = '');
        return connection.getCreateTempViewQuery(viewname, params.source, WorkflowCodeType.Full);
    }
}
ReadQuery.NAME = 'native.readquery';
export { ReadQuery };
